// features/auditHistorySlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchAuditHistory = createAsyncThunk(
  'auditHistory/fetchAuditHistory',
  async () => {
    console.log("audit history is call")
    const response = await axios.get('/api/audit_history');
    return response.data.auditRecords; // Adjust based on your API response structure
  }
);

const auditHistorySlice = createSlice({
  name: 'auditHistory',
  initialState: {
    auditRecords: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAuditHistory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAuditHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.auditRecords = action.payload;
      })
      .addCase(fetchAuditHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = 'Failed to fetch audit history.';
      });
  },
});

export const selectAuditHistory = (state) => state.auditHistory;

export default auditHistorySlice.reducer;
